import { render } from "./WithSlot.vue?vue&type=template&id=afbb80de&scoped=true"
import script from "./WithSlot.vue?vue&type=script&lang=js"
export * from "./WithSlot.vue?vue&type=script&lang=js"

import "./WithSlot.vue?vue&type=style&index=0&id=afbb80de&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afbb80de"]])

export default __exports__